import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Songlist from './pages/Songlist';
import Videos from './pages/Videos';
import Images from './pages/Images';
import { useKonamiCode } from './hooks/useKonamiCode';
import { usePartyMode } from './hooks/usePartyMode';
import PartyModeVideo from './components/PartyModeVideo';
import './App.css';
import './styles/party-mode.css';

const App: React.FC = () => {
  const { activatePartyMode, deactivatePartyMode, isActive: isPartyModeActive, showGifs, toggleGifs } = usePartyMode();
  
  // Activate party mode when Konami code is entered
  useKonamiCode(activatePartyMode);

  return (
    <Router>
      <div className="site-wrapper dark-theme">
        <PartyModeVideo 
          isActive={isPartyModeActive} 
          showGifs={showGifs}
          onClose={deactivatePartyMode}
          onToggleGifs={toggleGifs}
        />
        <header className="site-header">
          <Header />
        </header>
        <main className="site-main">
          <Routes>
            <Route path="/" element={<Home activatePartyMode={activatePartyMode} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/songlist" element={<Songlist />} />
            <Route path="/videos" element={<Videos isPartyModeActive={isPartyModeActive} />} />
            <Route path="/images" element={<Images />} />
          </Routes>
        </main>
        <footer className="site-footer">
          <Footer />
        </footer>
      </div>
    </Router>
  );
}

export default App;
